import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type SendMagicLinkMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  returnTo?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SendMagicLinkMutation = { __typename?: 'Mutation'; sendMagicLink: string };

export const SendMagicLinkDocument = gql`
  mutation sendMagicLink($email: String!, $returnTo: String) {
    sendMagicLink(email: $email, returnTo: $returnTo)
  }
`;
export type SendMagicLinkMutationFn = Apollo.MutationFunction<
  SendMagicLinkMutation,
  SendMagicLinkMutationVariables
>;

/**
 * __useSendMagicLinkMutation__
 *
 * To run a mutation, you first call `useSendMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMagicLinkMutation, { data, loading, error }] = useSendMagicLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      returnTo: // value for 'returnTo'
 *   },
 * });
 */
export function useSendMagicLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<SendMagicLinkMutation, SendMagicLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendMagicLinkMutation, SendMagicLinkMutationVariables>(
    SendMagicLinkDocument,
    options,
  );
}
export type SendMagicLinkMutationHookResult = ReturnType<typeof useSendMagicLinkMutation>;
export type SendMagicLinkMutationResult = Apollo.MutationResult<SendMagicLinkMutation>;
export type SendMagicLinkMutationOptions = Apollo.BaseMutationOptions<
  SendMagicLinkMutation,
  SendMagicLinkMutationVariables
>;
